import {z} from 'zod';
import {tradeMessageDbSchema} from './tradeMessageDbSchema';

export const tradeMessageSchema = tradeMessageDbSchema;

export interface TradeMessage extends z.infer<typeof tradeMessageSchema> {}
